// @ts-nocheck
import throttle from 'lodash-es/throttle';
import { nodeListToArray } from "../../../utils";
var mutationAttributes = ['data-aspm-click', 'data-aspm-expo', 'data-aspm', 'data-aspm-param'];
export function mutationCallback() {
  var mutationList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tracert = arguments.length > 1 ? arguments[1] : undefined;
  if (!mutationList || mutationList.length === 0) {
    return;
  }
  mutationList.forEach(function (mutation) {
    var _mutation$addedNodes = mutation.addedNodes,
      addedNodes = _mutation$addedNodes === void 0 ? [] : _mutation$addedNodes,
      _mutation$removedNode = mutation.removedNodes,
      removedNodes = _mutation$removedNode === void 0 ? [] : _mutation$removedNode,
      _mutation$type = mutation.type,
      type = _mutation$type === void 0 ? '' : _mutation$type;
    switch (type) {
      case 'attributes':
        /* An attribute value changed on the element in
         mutation.target.
         The attribute name is in mutation.attributeName, and
         its previous value is in mutation.oldValue. */
        // body自身没办法处理
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        mutation.target && tracert.expoCheck(mutation.target);
        break;
      case 'subtree':
      case 'childList':
        if (addedNodes && addedNodes.length) {
          /* One or more children have been added to and/or removed
           from the tree.
           (See mutation.addedNodes and mutation.removedNodes.) */
          // https://developer.mozilla.org/zh-CN/docs/Web/API/NodeList
          nodeListToArray(addedNodes).forEach(function (node) {
            return tracert.expoCheck(node);
          });
        }
        if (removedNodes && removedNodes.length) {
          checkRemovedNodes(nodeListToArray(removedNodes), tracert);
        }
        break;
      default:
        break;
    }
  });
}
function checkRemovedNodes(removedNodes, tracert) {
  var expoEndNodes = [];
  removedNodes.forEach(function (dom) {
    // self
    if (dom.getAttribute && dom.getAttribute('data-aspm-expo') !== null) {
      expoEndNodes.push(dom);
    }
    if (typeof dom.querySelectorAll === 'function') {
      expoEndNodes = expoEndNodes.concat(nodeListToArray(dom.querySelectorAll('[data-aspm-expo]')));
    }
  });
  expoEndNodes.forEach(function (dom) {
    // 获取dom上记录的曝光spmId
    var alreadyExpoSpm = dom[tracert._instanceId] || {};
    dom[tracert._instanceId] = {}; // reset null
    var keys = Object.keys(alreadyExpoSpm);
    keys.forEach(function (spmId) {
      if (alreadyExpoSpm[spmId] && (alreadyExpoSpm[spmId].status & 7) !== 0) {
        tracert._doExpo(spmId, dom, dom, {
          percent: 0,
          combineType: 'auto',
          expoState: 'end'
        });
      }
    });
  });
}
export function throttleMutation(callback, waitMs) {
  var allMutationList = [];
  var throttleCb = throttle(function () {
    // 防止执行_observerCb过程中，向里面增加新的变更
    var mutationList = [].concat(allMutationList);
    allMutationList.length = 0;
    callback(mutationList);
  }, waitMs, {
    leading: false,
    trailing: true
  });
  return function (mutationRecords) {
    mutationRecords.forEach(function (record) {
      var target = record.target,
        type = record.type;
      var isExist = allMutationList.find(function (item) {
        return item.target === target && item.type === type;
      });
      if (target && !isExist || type !== 'attributes') {
        allMutationList.push(record);
      }
    });
    throttleCb();
  };
}
export function createMutation(callback, targetNode) {
  var appendAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  if (!MutationObserver) {
    return null;
  }
  var mutation = new MutationObserver(callback);
  var targetDom = targetNode || document.querySelector('body');
  var options = {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: mutationAttributes.concat(appendAttrs)
    // characterData: true, 为什么要监听节点文本变化？
  };

  mutation.observe(targetDom, options);
  return mutation;
}